"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const coverageOptionItemRestrictions_1 = __importDefault(require("../coverageOptionItemRestrictions"));
class CoverageOptionItem {
    constructor(id, name, restrictions, icon, color) {
        this.id = id;
        this.name = name;
        this.restrictions = restrictions;
        this.icon = icon;
        this.color = color;
    }
    static fromObj(data) {
        var _a;
        return new CoverageOptionItem(data.id, data.name, coverageOptionItemRestrictions_1.default.fromObj((_a = data.restrictions) !== null && _a !== void 0 ? _a : {}), data.icon, data.color);
    }
}
exports.default = CoverageOptionItem;
//# sourceMappingURL=coverageOptionItem.class.js.map